module.exports = {
	"relBaseUrlAPi": "/api/v1",
	"relBaseUrlAuthAPi": "/v1",
	"absBaseUrlLiveFeed": "http://hls.iptv.optimum.net/news12/nipadlive/index_new.m3u8?callsign={callSign}",
	"absBaseUrlWeatherIcons": "http://images.itv.weather.news12.com/weather/images/612_36H_{regionId}.png?timestamp={timestamp}",
	"sessionStorageCacheExpiryMs": 300000
};


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/config.json
 ** module id = 277
 ** module chunks = 0
 **/